import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as keywordsPackActions from '../../actions/keywordsPackActions';
import * as spinnerActions from '../../actions/spinnerActions';
import * as modalActions from '../../actions/common/modalActions';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router-dom';
import MediaQuery from 'react-responsive';
import CustomModal from '../../components/CustomModal';
import {toastr} from 'react-redux-toastr';
import BaseList from '../../components/common/list/BaseList.jsx';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import PlaceholderError from "../common/PlaceholderError";
import PlaceholderTable from "../common/PlaceholderTable";
import KeywordsPackListDivs from "../keywords-pack/KeywordsPackListDivs";
import KeywordsPackList from "../keywords-pack/KeywordsPackList";

class KeywordsPackPage extends BaseList {
    constructor(props) {
        super(props);
        this.listId = 'keywords-packs';
        this.idToDelete = null;

        this.state = {
            page: 1,
            showDeleteModal: false,
            actions: this.getRequiredActions()
        };

        if (props.match.params.page) {
            this.state.page = props.match.params.page;
        }

        this.onDelete = this.onDelete.bind(this);
    }

    getRequiredActions() {
        return [
            this.props.actions.loadKeywordsPacks()
        ]
    }

    componentWillUpdate(nextProps, nextState){
        if (this.sortParamWasChanged(nextProps)) {
            nextState.page = 1;
        }
    }

    onDelete(id) {
        this.idToDelete = id;
        this.props.actions.showModal();
    }

    confirmDelete() {
        if (this.idToDelete !== null) {
            this.props.actions.deleteKeywordsPack(this.idToDelete).then(() => {
                this.idToDelete = null;
                this.props.actions.loadKeywordsPacks(this.state.page, this.getSortParams(this.props));
                // toastr.success(this.props.intl.formatMessage(messages.keywordsPackDeleted));
                toastr.success('Søgeordpakke slettet');
            })
            .catch((e) => {
                    toastr.error(e.toString());
                })
            .finally(() => {
                this.props.actions.hideModal();
            });
        } else {
            toastr.error('Kunne ikke slette søgeordpakke');
            // toastr.error(this.props.intl.formatMessage(messages.keywordsPackCouldNotDelete));
            this.props.actions.hideModal();
        }
    }

    hideDeleteModal() {
        this.idToDelete = null;
        this.props.actions.hideModal();
    }

    render() {
        const {keywordsPacks} = this.props;

        return (
            <WithResolvedPromises promises={this.state.actions} preloaderComponent={PlaceholderTable} errorComponent={PlaceholderError}>
            {
                addActions => {
                    return(
                        <div>
                            <CustomModal
                                modalTitle={`Slet søgeordpakke`/*this.props.intl.formatMessage(messages.keywordsPackDeleteModalTitle)*/}
                                modalContent={
                                    <p>
                                        Er du sikker på, at du vil slette denne søgeordpakke?
                                    </p>}
                                confirmText={this.props.intl.formatMessage(messages.deleteModalConfirmButton)}
                                closeText={this.props.intl.formatMessage(messages.deleteModalCancelButton)}
                                handleConfirm={() => {this.confirmDelete()}}
                            />
                            <div className="row">
                                <div className="col-12">
                                    <div className="card m-b-20">
                                        <div className="card-block">
                                            <div className='row'>
                                                <div className="col-sm-6">
                                                    <h1 className="mb-3">{`Søgeordpakker`/*this.props.intl.formatMessage(messages.keywordsPacks)*/}</h1>
                                                </div>
                                                <div className="col-sm-6 pt-2">
                                                    <Link
                                                        to="/søgeordpakker/skab"
                                                        className="btn btn-primary waves-effect pull-right"
                                                    >
                                                        {`Opret søgeordpakke`/*this.props.intl.formatMessage(messages.createKeywordsPack)*/}</Link>
                                                </div>
                                            </div>
                                            <MediaQuery query='(max-device-width: 768px)'>
                                                <KeywordsPackListDivs
                                                    keywordsPacks={keywordsPacks.data}
                                                    onDelete={this.onDelete}
                                                />
                                            </MediaQuery>
                                            <MediaQuery query='(min-device-width: 769px)'>
                                                <KeywordsPackList
                                                    keywordsPacks={keywordsPacks.data}
                                                    onDelete={this.onDelete}
                                                    listId={this.listId}
                                                />
                                            </MediaQuery>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }
            }
            </WithResolvedPromises>
        )
    }
}

KeywordsPackPage.contextTypes = {
    intl: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        keywordsPacks: state.keywordsPacks,
        showDeleteModal: state.showModal,
        sortableList: state.sortableList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...keywordsPackActions,
            ...spinnerActions,
            ...modalActions,
        }, dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(KeywordsPackPage));


// WEBPACK FOOTER //
// ./web/src/components/keywords-pack/KeywordsPackPage.jsx